import React, { useEffect, useState } from "react";
import { ApiURL } from "../../../../../services/apiConstants";
import { post } from "../../../../../services/services";
import SisLoader from "../../../../../widgets/loader";
import CoptDetailsTable from "../../components/CargoCraneCom/CoptRow";

function StaffCopt({ id }) {
  const [loader, setLoader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const fetchCoptList = async () => {
    setLoader(true);
    const formData = new FormData();
    formData.append("ship_id", id);

    try {
      const res = await post(ApiURL.list_cargo_machinery_copt_st, formData);
      if (res?.status === true) {
        setFilteredData(res?.response_data || []);
      }
    } catch (error) {
      console.error("Error fetching COPT list:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchCoptList();
  }, []);

  return (
    <>
      <h3 style={{ margin: "15px 0", fontWeight: "600" }}>COPT Information</h3>
      {loader ? (
        <SisLoader />
      ) : filteredData.length > 0 ? (
        <CoptDetailsTable data={filteredData} />
      ) : (
        <p>No data available</p>
      )}
    </>
  );
}

export default StaffCopt;
